// extracted by mini-css-extract-plugin
module.exports = {"container":"contract-for-supply_container__1TzGv","number":"contract-for-supply_number__2zRGi"};